module.exports = __webpack_public_path__ + "static/incubyte-slider-25297c301c383852ee82795352db863f.png";